import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { FormattedMessage } from 'react-intl'
import { DashButton } from 'legacy/dash-blocks/dash-button/DashButton'
import { Flex } from 'legacy/dash-blocks/flex/Flex'
import { DASH_FONT_STYLES } from 'legacy/dash-blocks/foundation/typography'
import Modal from 'legacy/components/Modal'
import { type ModalProps } from 'legacy/components/Modal/Modal.types'
import { type AisleVisibilityModalProps } from 'legacy/routes/catalog/departments/aisleVisibility/AisleVisibilityModals'
import { DashText } from 'legacy/dash-blocks/dash-text/DashText'
import { dashSpacing } from 'legacy/dash-blocks/foundation/spacing'

interface Props extends ModalProps, Pick<AisleVisibilityModalProps, 'aisleName'> {}

const BodyContainer = styled(Flex)`
  ${DASH_FONT_STYLES}
`

const AisleVisibilityWarningModal: FunctionComponent<Props> = ({ aisleName, onClose }) => {
  return (
    <div data-testid="aisle-visibility-warning-modal">
      <Modal width={550} onClose={onClose}>
        {(Header: React.ComponentType, Body: React.ComponentType, Footer: React.ComponentType) => [
          <Header data-testid="aisle-visibility-modal-header">
            <FormattedMessage id={`aisles.visibility.warningModal.title`} values={{ aisleName }} />
          </Header>,
          <Body data-testid="aisle-visibility-modal-body">
            <BodyContainer padding={['medium', 'large']}>
              <DashText elementType="p" overrideStyle={{ marginBottom: dashSpacing.SMALL }}>
                <FormattedMessage id={`aisles.visibility.warningModal.message`} />
              </DashText>
              <DashText elementType="p">
                <FormattedMessage id={`aisles.visibility.warningModal.filterMessage`} />
              </DashText>
            </BodyContainer>
          </Body>,
          <Footer>
            <Flex justify="center" overrideChildStyles={{ margin: 'xsmall' }}>
              <DashButton variant="outline" onClick={onClose}>
                <FormattedMessage id="common.close" />
              </DashButton>
            </Flex>
          </Footer>,
        ]}
      </Modal>
    </div>
  )
}

export default AisleVisibilityWarningModal
